import { Paper } from '@mui/material';
import { FC, useEffect, useMemo } from 'react';
import { GoPlus } from "react-icons/go";
import { useNavigate } from 'react-router-dom';
import { ConfirmDialog } from '../../../Components/Dialog/variants/dialog-confirmation/dialog-confirmation.component';
import { ActionButtons } from '../../../Components/Form/ActionButtons/action-buttons.component';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { Placeholder } from '../../../Components/Placeholder/placeholder.component';
import { Table } from '../../../Components/Table/table.component';
import { TableListSkeleton } from '../../../Components/Table/table-list-skeleton.component';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';


import { useListArts } from './arts-list.hook';
import { DestroyArtsUseCase } from '../../../Usecase/Arts/destroy-arts-usecase';
import { ListArtsUseCase } from '../../../Usecase/Arts/list-arts-usecase';

interface IOrdersSingleList {
  listArtsUseCase: ListArtsUseCase
  destroyArtsUseCase: DestroyArtsUseCase
}
const OrdersSingleList : FC<IOrdersSingleList> = ({ listArtsUseCase, destroyArtsUseCase }) => {
    const navigate = useNavigate()

    const {
      listArts,
      list,
      loading,
      loadError,
      setArtToDestroy,
      artToDestroy,
      handleDestroyArt,
      totalRegisters,
    } = useListArts({
      listArtsUseCase,
      destroyArtsUseCase,
    })

    useEffect(() => {
        listArts({ page: 1})
    }, [listArts])


    const columns = useMemo(() => {
        const createColumns: any[] = [
        
          {
            field: 'code',
            headerName: 'Código',
            width: 300,
          },
          {
            field: 'size',
            headerName: 'Tamanho',
            width: 300,
          },
          {
            field: "actions",
            headerName: "Ações",
            headerAlign: "right",
            flex: 1,
            renderCell: (params: any) => <ActionButtons params={params} setItemToDestroy={setArtToDestroy} editLink={`/art-form/${params.row.id}`} />
          }
        ];
      
        return createColumns;
      }, [setArtToDestroy]);
   

    return (
        <BaseScreen>
        <ConfirmDialog title='Remover pedido avulso' onCancel={() => setArtToDestroy('')} description='Você tem certeza?' open={!!artToDestroy} onConfirm={handleDestroyArt}  /> 
            <Paper >
                <BaseContentPage 
                    title='Pedidos de Venda (Avulso)'
                    breadcrumb={[{ title: 'Pedidos de Venda', link: "/orders-single-list"}, { title: 'Listagem'}]}
                    Action={() => <Button LeftIcon={() => <GoPlus size={18} />} sx={{ width: '130px'}} boxLeftSx={{ gap: '10px', marginLeft: '5px'}} textSx={{ textTransform: 'Capitalize', fontWeight: 500}} onClick={() => navigate('/orders-single-form')}>Adicionar</Button>}
                >
                  {!!list?.length ? (
                    <Table data={list} totalCount={totalRegisters} columns={columns} onPageChange={listArts} />
                  ) : loading ? (
                    <TableListSkeleton />
                  ) : loadError ? (
                    <Placeholder
                      description="Não foi possível carregar os pedidos avulsos."
                      onRetry={() => listArts({ page: 1 })}
                    />
                  ) : (
                    <Placeholder description="Nenhum pedido avulso encontrado." />
                  )}
                </BaseContentPage>
              
            </Paper>
                
        </BaseScreen>
    )
}

export { OrdersSingleList };
